<template>
    <admin-layout class="create-project" :show-sidebar="show_sidebar">
        <!-- TODO: Attach form submission with ajax call. -->
        <form class="create-project-content"
              action=""
              autocomplete="off"
              autocapitalize="off"
              @submit.prevent.stop>
            <div class="container-fluid wizard-progress-wrap mb-4">

                <h1 class="text-center" v-if="step.title">{{ step.title }}</h1>
                <p class="text-center" v-if="step.description">{{ step.description }}</p>

                <wizard-progress class="wizard-progress"
                                 :steps="progress.steps"
                                 :current="progress.current"
                                 :forward="false"/>

            </div>

            <!--        <pre>{{ {stack, length: stack.length, step_data} }}</pre>-->

            <select-path v-if="current_step_id === 'path'"
                         @update="update"
                         :errors="errors"
                         :value="step_data" />

            <div class="project-details" v-if="current_step_id === 'project'">
                <create-project :organizations="organizations"
                                :podcast_short_name="podcast_short_name"
                                @update="update"
                                :errors="errors"
                                :path_id="steps.path.data.id"
                                :value="step_data">Project Details</create-project>
            </div>

            <create-teams v-if="current_step_id === 'teams'"
                          @update="update"
                          :errors="errors"
                          :value="step_data">Project Details</create-teams>

            <div v-if="current_step_id === 'embed'">
                <div class="embed" v-if="tenant.meta?.embed" v-html="tenant.meta?.embed">

                </div>
            </div>

            <div class="container-fluid mt-5 mb-5 footer">
                <div class="d-flex py-3">
                    <button v-if="step.prev && !path_id"
                            class="btn"
                            :class="stack.length ? 'btn-dark' : 'btn-light'"
                            @click="back()"
                            :disabled="is_busy || !stack.length">{{ typeof step.prev_label !== 'undefined' ? step.prev_label : 'Back' }}</button>
                    <state-button class="btn btn-primary ml-auto"
                                  @click="next()"
                                  :state="is_busy ? 'busy' : ''"
                                  :disabled="is_busy || errors.length">{{ typeof step.next_label !== 'undefined' ? step.next_label : 'Next' }}</state-button>
                </div>
            </div>

<!--            <hr>-->
<!--            <h6>Wizard Data</h6>-->
<!--            <pre>{{ wizardData() }}</pre>-->
        </form>

        <div class="mb-3 py-1"></div>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import SelectPath from "@/Components/OnboardSteps/SelectPath";
import WizardProgress from "@/Components/OnboardSteps/WizardProgress";
import CreateProject from "@/Components/OnboardSteps/CreateProject";
import StateButton from "@/Components/Common/StateButton";
import jQuery from "jquery";
import themes from "@/DATA/themes";
import API from "@/API";
import CreateTeams from "@/Components/OnboardSteps/CreateTeams";

export default {
    name: "OnboardTeacher",
    components: {CreateTeams, CreateProject, SelectPath, AdminLayout, WizardProgress, StateButton},
    props: ['path_id', 'podcast_short_name', 'organizations', 'tenant'],

    data(){
        return {
            is_busy: false,

            errors: [],
            stack: [],
            current_step_id: '',

            steps: {
                path: {
                    title: 'Select Learning Path',
                    description: '',
                    auto_progress: true,
                    data: {
                        id: this.path_id,
                    },

                    async validate(path){
                        this.errors = [];
                        if( !path.id ) this.errors.push({ path: 'To proceed select a learning path first.'});
                    },

                    async next(){
                        this.current_step_id = 'project';
                    },
                },

                project: {
                    title: 'New Project Details',
                    data: {
                        organization_id: null,
                        name: '',
                        classroom: '',
                        theme: '',
                        podcasts: [],
                    },
                    async validate(project){
                        const errors = [];
                        if( !jQuery.trim( project.name ).length ){
                            errors.push({name: 'Project name is required.'});
                        }

                        if( !jQuery.trim( project.classroom ).length ){
                            errors.push({classroom: 'Classroom is required.'});
                        }
                        // if( !themes.filter(t => t.id == project.theme).length ){
                        //     errors.push({theme: 'Select an available goal.'});
                        // }

                        this.errors = errors;
                    },
                    async next(){
                        this.current_step_id = 'teams';
                    },
                    async prev(){
                        this.current_step_id = 'path';
                    },
                },

                teams: {
                    title: 'Create Teams (Optional)',
                    next_label: !this.tenant.meta.embed ? 'Create Change Project' : 'Next',
                    data: {
                        teams: []
                    },
                    async validate(teams){
                        const errors = [];
                        let total_length = 0;
                        for( let i = 0; i < teams.teams.length; i++ ){
                            const team = teams.teams[i];
                            const team_name_length = jQuery.trim( team.name ).length;
                            const students_length = jQuery.trim( team.students ).length;

                            total_length += (team_name_length + students_length);

                            if( team_name_length || students_length ){
                                if( !team_name_length ){
                                    const error = {};
                                    error[`team-name-${i}`] = 'Team name is required.';
                                    errors.push(error);
                                }
                            }

                            this.steps.teams.next_label = total_length > 0 ? 'Next' : 'Skip';

                        }
                        this.errors = errors;
                    },
                    async next(){
                        if(!this.tenant.meta.embed){
                            await this.createProject();
                            return;
                        }

                        this.current_step_id = 'embed';
                    },
                    async prev(){
                        this.current_step_id = 'path';
                    },
                },

                embed: {
                    title: '',
                    next_label: 'Create Change Project',
                    data: {

                    },
                    async validate(){
                        console.log("Submitting")
                    },
                    async next(){
                        await this.createProject();
                    },
                    async prev(){
                        this.current_step_id = 'path';
                    }
                }

            },
        }
    },

    computed: {

        wizard_data(){
            return this.wizardData();
        },

        show_sidebar(){
            return !(this.$page.props?.user?.is_teacher && this.$page.props?.user?.project_count === 0);
        },

        step(){
            return this.steps[ this.current_step_id ];
        },

        step_data:{
            get(){
                return this.step.data;
            },
            set(values){
                this.step.data = values;
            }
        },

        progress(){
            const steps = [];
            for( const key in this.steps ){
                if(! this.steps.hasOwnProperty(key)) continue;
                steps.push(this.steps[key].title);
            }

            const current = Object.keys( this.steps ).indexOf( this.current_step_id );
            return {steps, current};
        }

    },


    watch: {
    },


    methods: {

        back(){
            this.current_step_id = this.stack.pop();
            this.validate();
        },

        async next(){
            await this.validate();
            if( !this.errors.length ){
                this.stack.push( this.current_step_id );
                await this.step.next.apply(this);
            }
        },

        async update(values){

            console.log("UPDATE EVENT", JSON.parse(JSON.stringify(values)));

            const keys = Object.keys(values);
            for(const i in keys){
                this.step_data[ keys[i] ] = values[ keys[i] ];
            }

            if( this.step.auto_progress ){
                await this.next();
            }else{
                await this.validate();
            }

        },

        /**
         * Get the complete wizard data.
         *
         * @returns {{}}
         */
        wizardData(){
            const data = {};
            const keys = Object.keys( this.steps );
            for ( let i = 0; i < keys.length; i++ ){
                data[ keys[ i ] ] = this.steps[ keys[ i ] ].data;
            }
            console.log({wizard: data});
            return data;
        },

        async validate(){
            await this.step.validate.apply(this, [this.step_data, this.step]);
            return !!this.errors.length;
        },

        async createProject(){
            this.is_busy = true;
            try{
                const data = this.wizardData();

                /**
                 * Setting default team on skip
                 */
                if(data.teams.teams.length == 1){
                    if(!data.teams.teams[0].name){
                        data.teams.teams[0].name = 'Student Team'
                    }

                    if(!data.teams.teams[0].students){
                        data.teams.teams[0].students = 'Student'
                    }
                }

                if( typeof data.teams !== 'undefined' && typeof data.teams.teams !== 'undefined' ){
                    data.teams = data.teams.teams;
                }



                const project = await API.projects.create( data );
                this.$inertia.visit( this.route( 'project.learning-path', {project: project.id, ...this.global_url_params}) );
            }catch (error){
                console.log({error});
            }
        }

    },

    beforeMount() {
        this.current_step_id = Object.keys(this.steps)[0];
    },

    mounted() {

        if(!this.tenant.meta?.embed){
            delete this.steps['embed'];
        }

        // this.steps.path.data.id = this.$route?.query?.path;
        if( this.path_id ){
            this.next();
            return;
        }

        /**
         * The initial validation check done to make sure all
         * variables are set correctly.
         */
        // this.validate();
    }

}
</script>

<style lang="scss" scoped>
.wizard-progress-wrap{
    background: darken($light, 5%);
    padding: 1rem 0;

    h1{
        font-size: 1.6rem;
        margin-bottom: 1rem;
    }

    p{
        margin-bottom: 1rem;
    }
}
.wizard-progress{
    max-width: 600px;
    margin: 2rem auto 0;
}
.footer{
    background: darken($light, 10%);
}

.project-details{
    max-width: 1200px;
    margin: auto;
}
</style>
